<template>
    <div class="plan-badge">
        <div class="plan-info">
            <span class="plan-name">{{ planName }}</span>
            <span class="plan-divider">·</span>
            <span class="plan-tokens">{{ tokensUsed }}/{{ tokensTotal }}</span>
        </div>
        <button type="button" class="plan-action" @click="$emit('upgrade')">ОБНОВИТЬ</button>
        <div
            class="plan-progress"
            aria-hidden="true"
        >
            <div class="plan-progress-fill" :style="{ width: progressPercent + '%' }" />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    plan: { type: String, default: 'free' },
    tokensUsed: { type: Number, default: 0 },
    tokensTotal: { type: Number, default: 0 },
})

defineEmits(['upgrade'])

const planName = computed(() => (props.plan || 'free').toUpperCase())
const progressPercent = computed(() => {
    if (!props.tokensTotal) return 0
    return Math.min(100, Math.round((props.tokensUsed / props.tokensTotal) * 100))
})
</script>

<style scoped>
.plan-badge {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px 12px;
    border-top: 1px solid #E8E6E0;
    gap: 8px;
}

.plan-info {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: #23282C;
    font-weight: 600;
}

.plan-divider {
    color: #C4C2BC;
}

.plan-tokens {
    font-variant-numeric: tabular-nums;
}

.plan-action {
    background: transparent;
    border: 0;
    color: #E30613;
    font-family: inherit;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.4px;
    cursor: pointer;
}

.plan-action:hover {
    text-decoration: underline;
}

.plan-progress {
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 5px;
    height: 2px;
    background: #F1EFE8;
    border-radius: 2px;
    overflow: hidden;
}

.plan-progress-fill {
    height: 100%;
    background: #E30613;
    transition: width 0.3s ease;
}
</style>
